export default "__VITE_ASSET__CSdCzBAF__"